import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import showTranslated from "./showTranslated";
import showTextIds from "./showTextIds";
import enTranslation from "./translations/english";
import frTranslation from "./translations/french";
// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
const resources = {
  en: {
    translation: enTranslation,
  },
  fr: {
    translation: frTranslation,
  },
};

const useTranslated =
  localStorage.getItem("showTranslated") === "true" ||
  window.location.search.includes("showTranslated");

const useTextIds =
  localStorage.getItem("showTextIds") === "true" ||
  window.location.search.includes("showTextIds");

const postProcess = useTextIds
  ? ["showTextIds"]
  : useTranslated
  ? ["showTranslated"]
  : false;

i18n
  .use(showTranslated())
  .use(showTextIds())
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: "en", // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
    // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
    // if you're using a language detector, do not define the lng option
    postProcess,
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
